import { ChatWithBliksyRequestSchema, PresignBliksyUploadRequestSchema, PresignBliksyUploadResponseSchema } from './chat-with-bliksy.schema';
import { z } from 'zod';
/**
 * Chat With Bliksy Feature
 * Helpful Assistant to survey employees while recording process steps
 *
 * Response is now a stream (using AI SDK's pipeUIMessageStreamToResponse),
 * so we use a generic schema for the contract definition.
 */ export const chatWithBliksyContract = {
    method: 'POST',
    path: '/api/v2/bliksy/chat',
    description: 'Chat with bliksy ai assistant (streaming response)',
    requestSchema: ChatWithBliksyRequestSchema,
    responseSchema: z.any().describe('SSE stream following AI SDK UIMessage protocol'),
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - invalid or missing token or incorrect current password'
        }
    }
};
/**
 * Mints a presigned POST the browser submits directly to the object store.
 *
 * The upload never travels through the backend, but the destination is not the
 * client's to choose: the key is built from the caller's verified tenant and
 * user id plus the recording whose chat authorization this call just passed.
 *
 * Gated exactly like the turn route — an upload only ever exists to feed a chat
 * turn, so a caller who may not chat in this session must not be able to put
 * files into the bucket through it either.
 */ export const presignBliksyUploadContract = {
    method: 'POST',
    path: '/api/v2/bliksy/uploads/presign',
    description: 'Mint a presigned POST for a Bliksy chat attachment',
    requestSchema: PresignBliksyUploadRequestSchema,
    responseSchema: PresignBliksyUploadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad request - unsupported media type or oversize file',
            401: 'Unauthorized - invalid or missing token',
            403: 'AI disabled for the tenant, or the recording is not editable by this user',
            404: 'Step recording not found'
        }
    }
};

//# sourceMappingURL=chat-with-bliksy.contract.js.map